export enum CardEvents {
  NewCardButtonClicked = 'card.card.NewButtonClicked',
  MasterTagRemoved = 'card.card.MasterTagRemoved',
  CardCreated = 'card.card.Created',
  CardOpened = 'card.card.Opened'
}
